module.exports = __webpack_public_path__ + "img/background_c2.49e7d181.jpg";